<template>
  <div>
    <table width="100%" class="physicalExamTable">
      <tr v-if="!worksheet.decisionMaking2021 && !worksheet.decisionMaking2023" class="scoringHeader">
        <td class="physicalExamLabel">Physical Examination</td>
        <td>{{ scoring.examDetailType }}</td>
        <td>{{ scoring.examDetailScore }}</td>
      </tr>
      <tr v-else class="scoringHeader">
        <td colspan="3">Physical Examination</td>
      </tr>
      <tr>
        <td class="physicalExamLabel">Selected Elements</td>
        <td colspan="2">{{ scoring.examSelected }}</td>
      </tr>
    </table>

  </div>
</template>

<script>
  export default {
    name: 'ProWorksheetPhysicalExam',
    props: ['scoring', 'worksheet'],
    components: {
    },
    data() {
      return {

      }
    }
  }
</script>

<style scoped>
.physicalExamTable {
  table-layout: fixed;
  width: 100%;
}

.physicalExamTable .physicalExamLabel,
.physicalExamTable td:first-child {
  width: 28%;
  min-width: 150px;
  vertical-align: top;
  word-break: normal;
  overflow-wrap: normal;
  padding-right: 12px;
}
</style>
